import React from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useIsMobileDimensions } from '../_puzzles/shared/utils';
import AccountLinks from './components/AccountLinks';
import SignInDialog from './components/SignInDialog';
import './TopBar.less';

enum HolidayStyle {
  Halloween = 'halloween',
  Christmas = 'christmas',
}

type TopBarProps = {
  // save puzzle progress when navigating away by clicking logo
  onSave: () => void;
};

const TopBar = ({ onSave }: TopBarProps) => {
  const navigate = useNavigate();
  const isMobileDimensions = useIsMobileDimensions();

  // Set to a HolidayStyle enum value to activate holiday colors, or null for normal logo
  const activeHoliday: HolidayStyle | null = null;

  const holidayColors: Record<HolidayStyle, [string, string]> = {
    [HolidayStyle.Halloween]: ['blackLetter', 'orangeLetter'],
    [HolidayStyle.Christmas]: ['redLetter', 'greenLetter'],
  };

  const goTo = (url: string) => {
    return () => {
      navigate(url);
      window.scrollTo(0, 0);
      onSave();
    };
  };

  const keepTopBarOnMobile = ['/', '/submissions', '/account', '/about', '/on-ending-morphology'].includes(window.location.pathname);

  // the mobile games include the top bar themselves since they customize it
  if ((isMobile || isMobileDimensions) && !keepTopBarOnMobile) {
    // still need this even if top bar is missing. opens from stats dialog if logged out.
    return <SignInDialog/>;
  }

  const logoLetters = 'The Daily Baffle'.split('');

  return (
    <div className="topBar">
      <div className="logoHeader" onClick={goTo('/')}>
        {activeHoliday ? (
          logoLetters.map((letter, index) => (
            <span
              className={index % 2 === 0 ? holidayColors[activeHoliday][0] : holidayColors[activeHoliday][1]}
              key={index}
            >
              {letter}
            </span>
          ))
        ) : (
          'The Daily Baffle'
        )}
      </div>
      <AccountLinks/>
    </div>
  );
};

export default TopBar;